import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Item} from '../items';
import {ItemService} from '../items.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ParentShowComponent} from "../../../../components/parent-show";
import {Log} from "../../../../model/log";
import {ItemsGroupsShowComponent} from "../../itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {YearsShowComponent} from "../../years/years-show/years-show.component";
import {CurrencyMaskModule} from "ng2-currency-mask";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MessagesModule,CurrencyMaskModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        ItemsShowComponent
    ],
    entryComponents: [
        ItemsShowComponent
    ],
    exports: [],
    providers: [SharedService, ItemService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-items-show',
    templateUrl: './items-show.component.html',
    styleUrls: ['./items-show.component.scss'],
    providers: [ItemService, ConfirmationService, MessageService]
})

export class ItemsShowComponent implements OnInit, AfterViewInit {
    id: string;
    item = new Item();
    @Input() refShow;
    group: any[] = [];
    // picture:string;x
    applog: AppLogComponent;
    parent_name: any;
    parent:any;
    textcurralign = 'right';
    @Input() modelName;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() scrId;
  @Input() newDatap;

    modalRef: NgbModalRef;

    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private itemService: ItemService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(ItemsShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('items');


    }
    restoreLog() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
    /*    this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;*/
    }
    showParent(){
        if(this.parent) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    //
                    return true;
                }
            };
            this.modalRef = this.modalService.open(ItemsGroupsShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.item;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData) {

            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');


            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/items/edit', this.id]);
                });
            }
            if (this._deleteButton) {

                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteItem(this.item);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/items']);
                });

            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/items/search']);
                });

            }
        }

      const userdata = JSON.parse(localStorage.getItem('currentUser'));

      if (userdata && userdata.lang) {
        if(userdata.lang == 'ar') {
          this.textcurralign = 'right';
        } else {
          this.textcurralign = 'left';
        }
      }
    }

    ngOnInit() {

      const userdata = JSON.parse(localStorage.getItem('currentUser'));

      if (userdata && userdata.lang) {
        if(userdata.lang == 'ar') {
          this.textcurralign = 'right';
        } else {
          this.textcurralign = 'left';
        }
      }

      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
      };

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.router.navigated = false;
          window.scrollTo(0, 0);
        }
      });

       // console.log('reffffffffff'+ this.refShow);
        this.itemService.getAllGroups().subscribe(
            group => {
                this.group = group;
            });
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.parent_name = params['item_parent_group'];


        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),

            cost: new FormControl({value: '', disabled: true}),
            sale: new FormControl({value: '', disabled: true}),
            minimum_quantity: new FormControl({value: '', disabled: true}),
            barcode: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true}),
            items_groups_id: new FormControl({value: '', disabled: true}),
            picture: new FormControl({value: ''})

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
          this.newDatap = true;

            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.itemService.getById(this.id).subscribe(
                item => {
                    this.id = item.id;
                    this.item = item;
                    this.parent = item.items_groups_id;
                    this.form.patchValue({
                        id: item.id,
                        name: item.name,
                        cost: item.cost,
                        sale: item.sale,
                        minimum_quantity: item.minimum_quantity,
                        barcode: item.barcode,

                        status: item.status,
                        items_groups_id: item.items_groups_id,
                        picture: item.picture
                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
          this.newDatap = !this.newDatap ;

            this.itemService.getTrashedById(this.delId).subscribe(
                item => {
                    this.id = item.id;
                    this.item = item;
                    this.form.patchValue({
                        id: item.id,
                        name: item.name,
                        cost: item.cost,
                        sale: item.sale,
                        minimum_quantity: item.minimum_quantity,
                        barcode: item.barcode,
                        status: item.status,
                        items_groups_id: item.items_groups_id,
                        picture: item.picture
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

            this.itemService.getById(this.scrId).subscribe(
                item => {
                    this.id = item.id;
                    this.item = item;
                    this.form.patchValue({
                        id: item.id,
                        name: item.name,
                        cost: item.cost,
                        sale: item.sale,
                        minimum_quantity: item.minimum_quantity,
                        barcode: item.barcode,
                        status: item.status,
                        items_groups_id: item.items_groups_id,
                        picture: item.picture
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.item = this.newData;
            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                cost: this.newData.cost,
                city_id: this.newData.city_id,
                sale: this.newData.sale,
                minimum_quantity: this.newData.minimum_quantity,
                barcode: this.newData.barcode,
                status: this.newData.status,
                items_groups_id: this.newData.items_groups_id,
                picture: this.newData.picture
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.items.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteItem(item: Item) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (item) {
                    this.itemService.delete(item.id).subscribe(
                        res => {
                          let serv = 'success';
                          let messag = 'Delete completed';
                          if(res.result){
                            serv = 'success';
                            messag = 'Delete completed';
                          }else{
                            serv = 'error';
                            messag = res.message;
                          }

                            this.msgs = [];
                          this.msgs.push({
                            severity: serv,
                            summary: '',
                            detail: this.translate.instant(messag)
                          });
                          localStorage.setItem('showMessages', messag);
                          localStorage.setItem('statusMessages', serv);
                            setTimeout(() => {

                                this.router.navigate(['/items']);
                            },1000);
                            //localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                        }
                    );
                }
            }
        });
    }

    recoverEdit(item: Item) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (item) {
                    this.itemService.update(item).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/items/show', item.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.itemService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/items/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = ItemsShowComponent;

    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/items/items-show/items-show.component.ts